<template>
  <div class="cart-widget__items">
    <template
        v-for="cartItem in cartItems"
        :key="cartItem.key"
    >
      <AppCartItem
          v-if="!cartItem.product.isInternet"
          :product="cartItem.product"
          :item-key="cartItem.key"
          @remove="$.emit('remove', cartItem.key, cartItem.product)"
      />
      <AppCartItemInternet
          v-if="cartItem.product.isInternet"
          :product="cartItem.product"
          :item-key="cartItem.key"
          @remove="$.emit('remove', cartItem.key, cartItem.product)"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import CartItem from '@/classes/CartItem';
import AppCartItem from '@/components/cart/AppCartItem.vue';
import AppCartItemInternet from '@/components/cart/AppCartItemInternet.vue';
import {
  computed,
} from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const cartItems = computed<Array<CartItem>>(() => store.getters['cart/all']);
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.cart-widget__items {
  display: grid;
  grid-template-columns: 100%;
  gap: 20px;

  @media (min-width: map_get($grid-breakpoints, 'lg')) {
    gap: 30px;
  }
}
</style>
